import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PasswordValidators {
  static passwordStrength: ValidatorFn = (
    control: AbstractControl,
  ): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    let pwdStrength: any = { errors: [] };
    if (/[A-Z]+|[Ά-Ω]+/.test(value)) {
      pwdStrength = { ...pwdStrength, upperCaseTest: true };
    } else {
      pwdStrength = { ...pwdStrength, upperCaseTest: false };
      pwdStrength.errors = [
        ...pwdStrength.errors,
        $localize`Password must contain at least one upper case letter`,
      ];
    }

    if (/[a-z]+|[ά-ώ]+/.test(value)) {
      pwdStrength = { ...pwdStrength, lowerCaseTest: true };
    } else {
      pwdStrength = { ...pwdStrength, lowerCaseTest: false };
      pwdStrength.errors = [
        ...pwdStrength.errors,
        $localize`Password must contain at least one lower case letter`,
      ];
    }

    if (/[0-9]+/.test(value)) {
      pwdStrength = { ...pwdStrength, numericTest: true };
    } else {
      pwdStrength = { ...pwdStrength, numericTest: false };
      pwdStrength.errors = [
        ...pwdStrength.errors,
        $localize`Password must contain at least one number`,
      ];
    }

    return pwdStrength.upperCaseTest &&
      pwdStrength.lowerCaseTest &&
      pwdStrength.numericTest
      ? null
      : ({ pwdStrength: pwdStrength } as ValidationErrors);
  };

  static fieldMatch(matchTo: string, reverse?: boolean): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.parent && reverse) {
        const c = (control.parent?.controls as any)[matchTo] as AbstractControl;
        if (c) {
          c.updateValueAndValidity();
        }
        return null;
      }
      return !!control.parent &&
        !!control.parent.value &&
        control.value === (control.parent?.controls as any)[matchTo].value
        ? null
        : { matching: true };
    };
  }
}
